import axios from 'axios';
import { Loading, Message } from 'element-ui';

const BASE_URL = process.env.VUE_APP_BASE_URL;
const TIMEOUT = 10000;

const instance = axios.create({
  baseURL: BASE_URL,
  timeout: TIMEOUT,
});

let loadingInstance;
let requestCount = 0;

const startLoading = (target) => {
  if (requestCount === 0) {
    loadingInstance = Loading.service({
      target,
    });
  }
  requestCount++;
};

const stopLoading = () => {
  requestCount--;
  if (requestCount === 0 && loadingInstance) {
    loadingInstance.close();
  }
};

// const simulateNetworkDelay = (ms) => new Promise(resolve => setTimeout(resolve, ms))

instance.interceptors.request.use(
  async (config) => {
    if (config.showLoading) {
      // 只有当 showLoading 为 true 时才显示加载框
      startLoading(config.loadingTarget || '.loadingMain');
    }
    // await simulateNetworkDelay(4000) // 模拟500毫秒的网络延迟
    return config;
  },
  (error) => {
    if (error.config && error.config.showLoading) {
      stopLoading();
    }
    return Promise.reject(error);
  }
);

instance.interceptors.response.use(
  (response) => {
    if (response.config.showLoading) {
      stopLoading();
    }
    const responseData = response.data;
    if (responseData.code === 200) {
      if (response.config.showSuccessMessage) {
        Message.success(responseData.msg);
      }
      return responseData.data;
    } else if (responseData.code === 400) {
      Message.error(responseData.msg || '请求失败');
      return Promise.reject(new Error(responseData.msg || '请求失败'));
    } else {
      Message.warning(responseData.msg || '请求失败');
      return Promise.reject(new Error(responseData.msg || '请求失败'));
    }
  },
  (error) => {
    if (error.config && error.config.showLoading) {
      stopLoading();
    }
    if (error.response) {
      Message.error(error.response.data.msg || '请求失败');
    } else if (error.request) {
      Message.error('网络错误，请检查您的网络连接');
    } else {
      Message.error('请求配置错误');
    }
    return Promise.reject(error);
  }
);

export default instance;
